<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form
        :inline="true"
        size="small"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="违规内容名称">
          <el-input
            placeholder="请输入违规内容名称"
            v-model="formInline.search"
          >
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column
              prop="publisher_id"
              label="发布人"
            ></el-table-column>

            <el-table-column label="类型" width="120">
              <template #default="{row}">
                <el-tag :type="row.type === 'course' ? 'primary' : 'success'">
                  {{ row.type === "course" ? "课程" : "招聘信息" }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="关联内容">
              <template #default="{row}">
                <div v-if="row.type === 'course'">
                  <p v-if="row.course">{{ row.course.name }}</p>
                </div>
                <div v-else>
                  <p v-if="row.recruitmentInfo">
                    {{ row.recruitmentInfo.name }}
                  </p>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="状态" width="100">
              <template #default="{row}">
                <el-tag :type="row.vstatus === 0 ? 'danger' : 'success'">
                  {{ row.vstatus === 0 ? "未处理" : "已处理" }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="处理状态" width="100">
              <template #default="{row}">
                <div v-if="row.vstatus == 0">正常</div>
                <div v-if="row.vstatus == 1">已下架</div>
                <div v-if="row.vstatus == 2">已删除</div>
                <div v-if="row.vstatus == 3">已恢复</div>
              </template>
            </el-table-column>

            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="150"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.vstatus == 0"
                  size="small"
                  @click="
                    unShelve(scope.row, scope.row.type, scope.row.op_id, 1)
                  "
                  >下架</el-button
                >
                <el-button
                  v-if="scope.row.vstatus == 1"
                  size="small"
                  @click="
                    unShelve(scope.row, scope.row.type, scope.row.op_id, 0)
                  "
                  >重新上架</el-button
                >
                <el-button
                  v-if="scope.row.dstatus == 2"
                  size="small"
                  @click="Shelve(scope.row, scope.row.type, scope.row.op_id)"
                >
                  恢复
                </el-button>

                <el-button
                  v-if="scope.row.dstatus == 0"
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit
      :open_add="open_edit"
      :violation_content_id="violation_content_id"
      v-if="open_edit"
      @close="closeEdit"
    ></Edit>

    <el-dialog
      style="text-align: center"
      title="设置标题"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
    </el-dialog>
  </div>
</template>

<script>
import Violation_contentApi from "@/api/violation_content.js";
import Add from "./part/add.vue";
import Edit from "./part/edit.vue";

export default {
  components: {
    Add,
    Edit
  },
  inject: ["reload"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: ""
      },

      open_add: false,
      open_edit: false,
      violation_content_id: "",
      dialogVisible: false
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    // 下架方法
    unShelve(row, type, op_id, vstatus = 1) {
      var str = "确定要下架吗？";
      if (type == 0) {
        str = "确定要重新上架吗？";
      }

      this.$confirm(str, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          Violation_contentApi.unShelve({
            violation_content_id: row.violation_content_id, // 传递单个商品ID
            vstatus: vstatus,
            type: type,
            op_id: op_id
          })
            .then(data => {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.getTableList(); // 刷新列表
            })
            .catch(error => {
              this.$message.error("操作失败");
            });
        })
        .catch(() => {
          // 用户取消操作
        });
    },
    // 恢复操作
    Shelve(row, type, op_id) {
      this.$confirm("确定要恢复此内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          Violation_contentApi.Shelve({
            violation_content_id: row.violation_content_id,
            type: type,
            op_id: op_id
          })
            .then(data => {
              this.$message({
                message: "恢复成功",
                type: "success"
              });
              this.getTableList();
            })
            .catch(error => {
              this.$message.error("恢复失败");
            });
        })
        .catch(() => {});
    },
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    setting(e) {
      //违规内容标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      Violation_contentApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.violation_content_id = row.violation_content_id;
      this.open_edit = true;
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          Violation_contentApi.del(
            {
              violation_content_id: row.violation_content_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/violation_content/index/index.vue